<template>
  <div class="py-4 px-2 p-md-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="mb-0">License Management</h4>
      <a-button :loading="isLoading" @click="refreshData">
        <template #icon><i class="bi bi-arrow-clockwise"></i></template>
        Refresh
      </a-button>
    </div>

    <license-summary-card
      :summary="licenseSummary"
      :usage-percent="licenseUsagePercent"
      :loading="isFetchingSummary"
      class="mb-4"
    />

    <licensed-devices-table
      :devices="assignedDevices"
      :loading="isFetchingDevices"
    />
  </div>
</template>

<script>
import { inject } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import LicenseSummaryCard from './LicenseSummaryCard.vue';
import LicensedDevicesTable from './LicensedDevicesTable.vue';

export default {
  name: 'LicenseManagement',
  components: {
    LicenseSummaryCard,
    LicensedDevicesTable,
  },

  setup() {
    const toast = inject('toast');
    return { toast };
  },

  data() {
    return {
      isFetchingSummary: false,
      isFetchingDevices: false,
    };
  },

  computed: {
    ...mapGetters(['licenseSummary', 'licensingDevices', 'licenseUsagePercent']),
    isLoading() {
      return this.isFetchingSummary || this.isFetchingDevices;
    },
    assignedDevices() {
      return this.licensingDevices.filter(
        (device) => device.license_status === 'assigned'
      );
    },
  },

  created() {
    this.loadData();
  },

  methods: {
    ...mapActions(['fetchLicenseSummary', 'fetchLicensingDevices']),

    async loadData() {
      await Promise.all([this.loadSummary(), this.loadDevices()]);
    },

    async loadSummary() {
      this.isFetchingSummary = true;
      const [error] = await this.fetchLicenseSummary();
      this.isFetchingSummary = false;
      if (error) {
        this.handleError(error, 'Failed to load license summary');
      }
    },

    async loadDevices() {
      this.isFetchingDevices = true;
      const [error] = await this.fetchLicensingDevices();
      this.isFetchingDevices = false;
      if (error) {
        this.handleError(error, 'Failed to load devices');
      }
    },

    refreshData() {
      this.loadData();
    },

    handleError(error, defaultMessage) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        defaultMessage;
      this.toast.error(errorMessage);
    },
  },
};
</script>

<style scoped>
h4 {
  color: #213547;
}
</style>
